<div class="skeleton">
  <div class="skeleton__brand-name skeleton--animated"></div>
  <div class="skeleton__stores-included skeleton--animated"></div>
  <div class="skeleton__traffic skeleton--animated"></div>
  <div class="skeleton__percentage-change skeleton--animated"></div>
</div>
